import { ApiBase } from '@/api/methods/ApiBase'

export namespace ActivateUsersApi {
  /**
   * ユーザ有効化API
   *
   * @param activateToken トークン情報
   * @param password パスワード
   */
  export async function createUser(activateToken: string, password: string): Promise<void> {
    const params = {
      activateToken: activateToken,
      password: password,
    }
    await ApiBase.post('/activate/users', params)
  }
}
